import React from 'react';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';
import Text from '../../components/text/Text';
import { ProjectSection } from '../../components/ProjectSection';
import { researchData } from '../../data/research';

function Research() {
    return (
        <body>
            <Navbar />
            <hr className='hr-min' />
            <div className='container'>
                <Text as='h1' fontSize={56} variant='yellow-green'>Linhas de Pesquisa</Text>
            </div>

            {researchData.map((project, index) => (
                <React.Fragment key={project.id}>
                    <ProjectSection
                        project={project}
                        // Se o índice for ímpar o isReversed será true
                        isReversed={index % 2 !== 0}
                    />
                    {index < researchData.length - 1 && <hr className='hr-min' />}
                </React.Fragment>
            ))}

            <Footer />
        </body>
    );
}

export default Research;